import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { Fab, FabProps, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SubIngredientsButtonProps extends FabProps {
  version: 'add' | 'edit';
}

const SubIngredientsButton: React.FC<SubIngredientsButtonProps> = ({
  version,
  onClick,
}) => {
  const { t } = useTranslation();
  const { palette } = useTheme();
  const isEditVersion = version === 'edit';

  return (
    <Fab
      variant="extended"
      onClick={onClick}
      sx={{
        bgcolor: palette.grey[600],
        height: '24px',
        gap: 0.5,
        px: 1,
        zIndex: 0,
        color: '#FFF',
        '& > svg': { fontSize: '1rem' },
        '&:hover': { bgcolor: palette.grey[500] },
      }}
    >
      <Typography
        variant="body2"
        color="inherit"
        sx={{
          textTransform: 'none',
          fontSize: '0.75rem',
          lineHeight: '1.245',
        }}
      >
        {t(`edit-label.ingredients-section.${version}-ingredients`)}
      </Typography>
      {isEditVersion ? <EditIcon /> : <AddIcon />}
    </Fab>
  );
};

export default SubIngredientsButton;
